import axios from "axios";
import {DASHBOARD_API_URL, CUSTOMER_SERVICE_API_URL,REPORT_VIEWER_API_URL} from "../constants/api_routes";
import { REPORT } from "../constants/app_routes";
import {getHeader, signOut} from "./user_api";

export const getDashboardData = async (startDate,endDate) => {
    try {
        const response = await axios.get(`${DASHBOARD_API_URL}/inspection_status?start_date=${startDate}&end_date=${endDate}`, {headers: getHeader()});
        return response.data;
    } catch (e) {
        return {
            message: "Something Went wrong. Try Again",
            status: e.response.status
        };
    }
};
export const getKnowledgeBaseData = async (initial=false) => {
    try {
        const response = await axios.get(`${DASHBOARD_API_URL}/knowledge_base${initial ? "?initial=true" : ""}`, {headers: getHeader()});
        return {articles:response.data,
        success:true}
    } catch (e) {
        return {
            message: "Something Went wrong. Try Again",
            status: e.response.status,
        };
    }
};

export const createKnowledgeArticle = async (formData,edit) => {
    try {
        let response = undefined
        if(!edit){
            response = await axios.post(`${DASHBOARD_API_URL}/knowledge_base`,formData,{headers: getHeader()});
        }
        else {
            response = await axios.put(`${DASHBOARD_API_URL}/knowledge_base`,formData,{headers: getHeader()});  
        }
        return response.data;
    } catch (e) {
        return {
            message: "Something Went wrong. Try Again",
            status: e.response.status
        };
    }
};
export const updateKnowledgeArticle = async (formData) => {
    try {
        const response = await axios.put(`${DASHBOARD_API_URL}/knowledge_base`,formData,{headers: getHeader()});
        return response.data;
    } catch (e) {
        return {
            message: "Something Went wrong. Try Again",
            status: e.response.status
        };
    }
};
export const deleteKnowledgeArticle = async (articleId) => {
    try {
        const response = await axios.delete(`${DASHBOARD_API_URL}/knowledge_base?id=${articleId}`, {headers: getHeader()});
        return response.data;
    } catch (e) {
        return {
            message: "Something Went wrong. Try Again",
            status: e.response.status
        };
    }
};


export const getClerkStatisticsData = async (startDate,endDate) => {
    try {
        const response = await axios.get(`${DASHBOARD_API_URL}/clerk_inspection_status?start_date=${startDate}&end_date=${endDate}`, {headers: getHeader()});
        return response.data;
    } catch (e) {
        return {
            message: "Something Went wrong. Try Again",
            status: e.response.status
        };
    }
};

export const getMessages = async () => {
    try {
        const response = await axios.get(`${DASHBOARD_API_URL}/messages`, {headers: getHeader()});
        return response.data;
    } catch (e) {
        return {
            message: "Something Went wrong. Try Again",
            status: e.response.status
        };
    }
};

export const createMessage = async (formData) => {
    try {
        const res = await axios.post(`${DASHBOARD_API_URL}/messages`, formData, {headers: getHeader()});
        return ({
            success: res.data.success,
            statusMessage: "Created message"
        });
    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
};

export const removeMessage = async (message_id) => {
    try {
        const res = await axios.delete(`${DASHBOARD_API_URL}/messages`, {headers: getHeader(),data:{message_id:message_id}});
        return ({
            success: res.data.success,
            statusMessage: "Deleted message"
        });
    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
}

export const getChasingData = async () => {
    try {
        const response = await axios.get(`${DASHBOARD_API_URL}/chasing`, {headers: getHeader()});
        return response.data;
    } catch (e) {
        return {
            message: "Something Went wrong. Try Again",
            status: e.response.status
        };
    }
};

export const getPVChasingData = async () => {
    try {
        const response = await axios.get(`${DASHBOARD_API_URL}/chasing_pv`, {headers: getHeader()});
        return response.data;
    } catch (e) {
        return {
            message: "Something Went wrong. Try Again",
            status: e.response.status
        };
    }
};

export const getLastInspectionData = async () => {
    try {
        const response = await axios.get(`${DASHBOARD_API_URL}/last_inspections_booked`, {headers: getHeader()});
        return response.data;
    } catch (e) {
        return {
            message: "Something Went wrong. Try Again",
            status: e.response.status
        };
    }
};

export const getProvisionalOfferData = async () => {
    try {
        const response = await axios.get(`${DASHBOARD_API_URL}/provisional_offers`, {headers: getHeader()});
        return response.data;
    } catch (e) {
        return {
            message: "Something Went wrong. Try Again",
            status: e.response.status
        };
    }
};

export const getProvisionallyOfferedClerks = async (inspection_id) => {
    try {
        const response = await axios.get(`${DASHBOARD_API_URL}/provisional_clerks?id=${inspection_id}`, {headers: getHeader()});
        return response.data;
    } catch (e) {
        return {
            message: "Something Went wrong. Try Again",
            status: e.response.status
        };
    }
};

export const createClerkOffer = async (inspection_id,user_id) => {
    try {
        const res = await axios.post(`${DASHBOARD_API_URL}/provisional_offers`, {inspection_id:inspection_id,user_id:user_id}, {headers: getHeader()});
        return ({
            success: res.data.success,
            statusMessage: "Created clerk offer"
        });
    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
};

export const removeClerkOffer = async (inspection_id, user_id) => {
    try {
        const res = await axios.delete(`${DASHBOARD_API_URL}/provisional_offers`, {headers: getHeader(),data:{inspection_id:inspection_id,user_id:user_id}});
        return ({
            success: res.data.success,
            statusMessage: "Deleted clerk offer"
        });
    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
}

export const acceptClerkOffer = async (inspection_id) => {
    try {
        const res = await axios.post(`${DASHBOARD_API_URL}/provisional_offer_accept`, {inspection_id:inspection_id}, {headers: getHeader()});
        return ({
            success: res.data.success,
            statusMessage: "Accepted clerk offer"
        });
    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
};

/* CUSTOMER SERVICE SECTION */

export const getCustomerServiceQueriesForInspection = async (inspection_id) => {
    try {
        const response = await axios.get(`${CUSTOMER_SERVICE_API_URL}/queries?id=${inspection_id}`, {headers: getHeader()});
        return response.data;
    } catch (e) {
        return {
            message: "Something Went wrong. Try Again",
            status: e.response.status
        };
    }
};

export const createCustomerServiceQuery = async (formData, token) => {
    try {
        let url = null
        if (token) {
            url = REPORT_VIEWER_API_URL
        } else
            {url = CUSTOMER_SERVICE_API_URL}

        const res = await axios.post(`${url}/create`, formData, {headers: getHeader()});
        return ({
            success: res.data.success,
            statusMessage: "Created CS QUERY",
            query_id:res.data.query_id
        });
    } catch (error) {
        return ({
            success: false,
            statusMessage: error.response.data.error,
            status:error.response.status
        });
    }
};

export const createQuickComment = async (formData) => {
    try {
        let url = CUSTOMER_SERVICE_API_URL

        const res = await axios.post(`${url}/create_quick_comment`, formData, {headers: getHeader()});
        return ({
            success: res.data.success,
            statusMessage: "Created CS QUERY",
            query_id:res.data.query_id
        });
    } catch (error) {
        return ({
            success: false,
            statusMessage: error.response.data.error,
            status:error.response.status
        });
    }
};

export const uploadCustomerServiceQueryImages = async (formData, token) => {
    try {
        let url = null
        if (token) {
            url = REPORT_VIEWER_API_URL
        } else
            {url = CUSTOMER_SERVICE_API_URL}

        const res = await axios.post(`${url}/upload_query_images`, formData, {headers: getHeader()});
        return ({
            success: res.data.success,
            statusMessage: "UPLOADED IMAGE"
        });
    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
};

export const notifyUser = async (formData, token) => {
    try {
        let url = null
        if (token) {
            url = REPORT_VIEWER_API_URL
        } else
            {url = CUSTOMER_SERVICE_API_URL}

        const res = await axios.post(`${url}/notify`, formData, {headers: getHeader()});
        return ({
            success: res.data.success,
            statusMessage: "Sent Email"
        });
    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
};

export const updateCustomerServiceQueryByID = async (query_ID,formData) => {
    try {
        const res = await axios.put(`${CUSTOMER_SERVICE_API_URL}/${query_ID}`, formData, {headers: getHeader()});
        return ({
            success: res.data.success,
            statusMessage: "Successfully Uploaded!!!"
        });
    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
};

export const updateClerkComment = async (formData) => {
    try {
        const res = await axios.post(`${CUSTOMER_SERVICE_API_URL}/update_clerk_comment`, formData, {headers: getHeader()});
        return ({
            success: res.data.success,
            statusMessage: "Successfully Uploaded!!!"
        });
    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
};

export const deleteCustomerServiceQuery = async (query_id) => {
    try {
        const res = await axios.delete(`${CUSTOMER_SERVICE_API_URL}/${query_id}`, {headers: getHeader(),data:{query_id:query_id}});
        return ({
            success: res.data.success,
            statusMessage: "Deleted CS QUERY"
        });
    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
}

export const uploadQueryImage = async (formData) => {
    let res = {}
    try {
        res = await axios.post(`${CUSTOMER_SERVICE_API_URL}/upload_query_images`, formData , { headers: getHeader() });
        return ({
            success:true,
            statusMessage:"Image Added Successfully!"
        })
    }
    catch (error) {
        return ({
            success:false,
            statusMessage:res.error
        })
    }
}

export const deleteQueryImage = async (imageId) => {
    let res ={};
    try {
        res = await axios.post(`${CUSTOMER_SERVICE_API_URL}/delete_customer_service_query_images` ,{image_id:imageId}, { headers: getHeader() });
        return ({
            success:true,
            statusMessage:"Image Removed Successfully!"
        })

    } catch (error){
        return ({
            success:false,
            statusMessage:res.error
        })
    }
};

export const getCustomerServiceByDate = async (URL, startDate, endDate) => {
    try {
        const res = await axios.get(`${URL}/list?start_date=${startDate}&end_date=${endDate}`, {headers: getHeader()});
        return res.data;
    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
};

export const getPropertyVisitsByDate = async (URL, startDate, endDate) => {
    try {
        const res = await axios.get(`${URL}/list?start_date=${startDate}&end_date=${endDate}`, {headers: getHeader()});
        return res.data;
    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
};
export const getPropertyVisitsByAddress = async (URL, address) => {
    try {
        const res = await axios.get(`${URL}/address?address=${address}`, {headers: getHeader()});
        return res.data;
    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
};

export const getExpenseFormList = async () => {
    try {
        const res = await axios.get(`${DASHBOARD_API_URL}/expenses`, {headers: getHeader()});
        return res.data;
    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
};
export const getExpenseImage = async (imageID) => {
    try {
        const res = await axios.get(`${DASHBOARD_API_URL}/expense_image?id=${imageID}`, {headers: getHeader()});
        return res.data;
    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
};

export const deleteExpenseForm = async (formID) => {
    try {
        const res = await axios.delete(`${DASHBOARD_API_URL}/expenses?id=${formID}`, {headers: getHeader()});
        return ({success:true});
    } catch (error) {
        return ({
            success: false,
            statusMessage: "Something went wrong. Try again.",
            status:error.response.status
        });
    }
};

export const uploadExpenseForm = async (formData) => {
    let response;
    try {
        response = await axios.post(`${DASHBOARD_API_URL}/expenses`,formData,{headers: getHeader()});
        if(response.data.success){
            return ({
                success:true,
                statusMessage:"Rooms added successfully !!",
                formId:response.data.formId
            })
        }
        else {
            return ({
                success:false,
                statusMessage:response.error
            })
        }

    } catch (error){
        return ({
            success:false,
            statusMessage:error
        })
    }
};

export const uploadExpenseImages = async (formData) => {
    let response;
    try {
        response = await axios.post(`${DASHBOARD_API_URL}/expense_images`,formData,{headers: getHeader()});
        if(response.data.success){
            return ({
                success:true,
                statusMessage:"expense Image added successfully !!"
            })
        }
        else {
            return ({
                success:false,
                statusMessage:response.error
            })
        }

    } catch (error){
        return ({
            success:false,
            statusMessage:error.response.data.error
        })
    }
};
/* All file downloads via API */

export const downloadFile = async (URL) => {
    try {
        return await axios.get(`${URL}`,{headers:getHeader(),responseType: 'arraybuffer', dataType:'blob'});

    } catch (e){
        return {
            success:false,
            status:e.response.status
        }
    }
};


// WEBPACK FOOTER //
// ./src/data/dashboard_api.js